import { render, staticRenderFns } from "./createCoupon.vue?vue&type=template&id=5c2bc9f2&scoped=true&"
import script from "./createCoupon.vue?vue&type=script&lang=js&"
export * from "./createCoupon.vue?vue&type=script&lang=js&"
import style0 from "./createCoupon.vue?vue&type=style&index=0&id=5c2bc9f2&lang=scss&scoped=true&"
import style1 from "./createCoupon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bc9f2",
  null
  
)

export default component.exports